import { render, staticRenderFns } from "./anomaly-class.vue?vue&type=template&id=179b735c"
import script from "./anomaly-class.vue?vue&type=script&lang=js"
export * from "./anomaly-class.vue?vue&type=script&lang=js"
import style0 from "./anomaly-class.vue?vue&type=style&index=0&id=179b735c&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179b735c')) {
      api.createRecord('179b735c', component.options)
    } else {
      api.reload('179b735c', component.options)
    }
    module.hot.accept("./anomaly-class.vue?vue&type=template&id=179b735c", function () {
      api.rerender('179b735c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/anomaly-class.vue"
export default component.exports